(function ($) {
    'use strict';
    /**
     * плагин масштабирвоания текста
     * */
    $.fn.ordCreative = function () {
        var $self = $(this);
        var selectors = {
            openButton: '.js-ord-item-button-open',
            closeButton: '.js-ord-item-button-close',
            copyButton: '.js-ord-item-button-copy',
            copyText: '.js-ord-item-copy-text',
            resultText: '.js-ord-item-copy-result',
        };
        var OPEN_CLASS = 'open';
        var $openButton = $self.find(selectors.openButton);
        var $closeButton = $self.find(selectors.closeButton);
        var $copyButton = $self.find(selectors.copyButton);
        var $resultText = $copyButton.find(selectors.resultText);
        var $copyTextWrapper = $copyButton.find(selectors.copyText);
        var copyText = $copyTextWrapper.text();
        var chagedText = {
            default: 'Скопировать токен',
            changed: 'Скопировано',
        };

        var flag = false;

        /**
         * прослушиватель на открыть
         */
        var addHandlerOpen = function () {
            $openButton.on('click', function () {
                $('.js-ord-item').removeClass(OPEN_CLASS);
                $self.addClass(OPEN_CLASS);
            });
        };

        /**
         * прослушиватель на закрыть
         */
        var addHandlerClose = function () {
            $closeButton.on('click', function () {
                $self.removeClass(OPEN_CLASS);
            });
        };

        /**
         * заменяем текст
         */
        var changeText = function (returned) {
            returned ? $resultText.text(chagedText.default) : $resultText.text(chagedText.changed);
        }

        /**
         * копируем
         */
        var addHandlerCopy = function () {
            $copyButton.on('click', function () {
                var $temp = $('<input>');
                $('body').append($temp);
                $temp.val(copyText).select();
                document.execCommand('copy');
                $temp.remove();
                if (flag) {
                    return;
                }
                changeText();
                setTimeout(function () {
                    changeText(true);
                    flag = false;
                }, 2000);
            })
        };

        /**
         * инициализация плагина
         * */
        var init = function () {
            addHandlerOpen();
            addHandlerClose();
            addHandlerCopy();
        };
        init();
        return this;
    };
    $('.js-ord-item').each(function () {
        $(this).data('ordCreative', $(this).ordCreative());
    });
})(jQuery);

